module.exports = __webpack_public_path__ + "img/crsl-impf-1.6248cd38.png";